import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import ViewFiles from "../documents/ViewFiles";
import { useSelector } from "react-redux";
const Whistleblowing = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [attributes] = useState([
    
    {
      type: "text",
      placeholder: "id",
      name: "ID",
      tab: "details",
      validation: "",
      default: "",
      label: "id",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "enterTopic",
      name: "title",
      tab: "details",
      validation: "",
      default: "",
      label: "topic",
      required: true,
      view: true,
      add: true,
      update: true,
      disabled: true
    },
    {
      type: "select",
      placeholder: "select",
      name: "location",
      tab: "details",
      validation: "",
      default: "",
      label: "location",
      showItem: "title",
      required: true,
      view: false,
      filter: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "location/select",
      disabled: true
    },
    {
      type: "select",
      placeholder: "select",
      name: "category",
      tab: "details",
      validation: "",
      default: "",
      label: "category",
      showItem: "locale",
      required: true,
      view: true,
      filter: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "whistle-category/select",
      disabled: true
    },
    {
      type: "select",
      placeholder: "select",
      name: "level",
      tab: "details",
      validation: "",
      default: "",
      label: "priority",
      required: true,
      view: true,
      filter: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi:[
        {id: "low", value: t("low")},
        {id: "medium", value: t("medium")},
        {id: "high", value: t("high")}
      ]
    },
    {
        type: "date",
        placeholder: "selectDate",
        name: "nextDeadline",
        tab: "details",
        validation: "date",
        default: "empty",
        label: "nextDeadline",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
    },
    {
        type: "date",
        placeholder: "selectDate",
        name: "updatedAt",
        tab: "details",
        validation: "date",
        default: "empty",
        label: "lastActivity",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
        disabled: true
    },
    {
      type: "text",
      placeholder: "description",
      name: "description",
      tab: "details",
      validation: "",
      default: "",
      label: "description",
      required: true,
      view: false,
      add: true,
      update: true,
      disabled: true
    },
    {
      type: "expired",
      placeholder: "status",
      tab: "details",
      name: "status",
      validation: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("whistleblowing")} - PersoBase`;
  }, [t]);


  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable formView="tabs" profileImage={false} bulkUplaod={true} {...props} api={`whistleblowing`} actions={[]} itemTitle={`fullName`} shortName={`whistleblowingCases`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={true} selectPrivilege={true} attributes={attributes} cases={true}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Whistleblowing);
